var $ = global.jQuery = global.$;
var widgets = require('../lib/widgets');

var _Base = require('./_Base');

var UploadField = _Base.extend({
  init: function() {
    var self = this;
    this.$area = this.$el.parent();
    this.$itemList = this.$area.find('[data-uploads]');
    this.$input = this.$el.find('input[type=file]');
    this.$label = this.$el.find('label');
    this.$uploadAnother = this.$el.find('[data-upload-another]');
    this.$uploadClear = this.$area.find('[data-upload-clear]');
    this.clearInputHolder = this.$uploadClear.find('.upload-clear__input-holder');
    this.clearInputList = this.clearInputHolder.find('input');
    this.$originalInput = this.$input.clone();
    this.$input.on('change', function() {
      if (this.value !== '') {
        self.addFile();
      }
    });
    this.files = [];
    this.$el.attr('tabindex', 0);
    this.$label.on('click', function(event) {
      event.preventDefault();
      self.$input.click();
    });
    if (!this.$itemList.is(':empty')) this.$uploadClear.show();
  },
  addFile: function() {
    var self = this;
    this.$el.trigger('Files:updated',[this.$input[0].files]);
    if (this.$input[0].files.length) {
      this.$uploadAnother.show();
      this.$uploadClear.show();
    }
    this.$input = this.$originalInput.clone();
    this.$input.on('change', function() {
      if (this.value !== '') {
        self.addFile();
      }
    });
    this.$el.append(this.$input);
    this.$input.valid();
  },
  clearList: function() {
    var $inputs = this.$el.find('input[type=file]');
    for (var i = 0; i < $inputs.length - 1; i++){
      $inputs[i].remove();
    }
    this.$uploadAnother.hide();
    this.$uploadClear.hide();
    this.clearInputList.each(function(index, el) {
      $(el).attr("checked", true);
      el.value = true;
    });
    this.$input.valid();
  }
});

module.exports = UploadField;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/UploadField.js
// module id = 121
// module chunks = 0